/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LocalityOpeningHoursResponse,
    LocalityOpeningHoursResponseFromJSON,
    LocalityOpeningHoursResponseFromJSONTyped,
    LocalityOpeningHoursResponseToJSON,
} from './LocalityOpeningHoursResponse';

/**
 * 
 * @export
 * @interface LocalityOpeningHoursListResponse
 */
export interface LocalityOpeningHoursListResponse {
    /**
     * 
     * @type {Array<LocalityOpeningHoursResponse>}
     * @memberof LocalityOpeningHoursListResponse
     */
    items: Array<LocalityOpeningHoursResponse>;
}

export function LocalityOpeningHoursListResponseFromJSON(json: any): LocalityOpeningHoursListResponse {
    return LocalityOpeningHoursListResponseFromJSONTyped(json, false);
}

export function LocalityOpeningHoursListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LocalityOpeningHoursListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(LocalityOpeningHoursResponseFromJSON)),
    };
}

export function LocalityOpeningHoursListResponseToJSON(value?: LocalityOpeningHoursListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(LocalityOpeningHoursResponseToJSON)),
    };
}

